import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import AddSliderComponent from '../components/AddSliderComponent';
import HeaderComponent from '../components/HeaderComponent';

class AddSliderPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <AddSliderComponent />
            </div>
        );
    }
}

export default AddSliderPage;